import { OrderApiClient } from '@fourthwall/services/dist/OrderApiClient'
import { createMutationHook } from '@fourthwall/utils'

export const useUpdatePhoneMutation = createMutationHook(OrderApiClient.updatePhone, {
  mutationKey: ['updatePhone'],
})
